import { Clear, InfoOutlined } from '@mui/icons-material'
import { Grid, Button, CardActions, Dialog, DialogContent, DialogTitle, Divider, IconButton, Typography, useMediaQuery, Tooltip } from '@mui/material'
import moment from 'moment'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ALL_FAILED_ORDER_STATUS, ROLES } from 'src/constants'

export default function ShipmentFailReasonDialog({ failedStatus }) {
    const { t } = useTranslation()

    const fullScreen = useMediaQuery(theme => theme.breakpoints.down('md'));
    const [open, setOpen] = useState(false)

    return (
        <>
            <Dialog
                maxWidth="md"
                fullWidth
                fullScreen={fullScreen}
                open={open}
                aria-labelledby="guard-dialog-title"
                disableScrollLock
            >
                <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    {t("Fail reason")}
                    <IconButton onClick={() => setOpen(false)} color="primary">
                        <Clear />
                    </IconButton>
                </DialogTitle>
                <Divider />
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid item xs={6} sx={{ display: "flex", alignItems: "center" }}>
                            <Typography fontWeight="bold" sx={{ mr: 1.5 }} color="text.lighter" variant='body2'>
                                {t("Status")}
                            </Typography>
                            <Typography variant="h6">
                                {ALL_FAILED_ORDER_STATUS.includes(failedStatus?.status) ? t("Shipment creation failed") : t(failedStatus?.status)}
                            </Typography>
                        </Grid>
                        <Grid item xs={6} sx={{ display: "flex", alignItems: "center" }}>
                            <Typography fontWeight="bold" sx={{ mr: 1.5 }} color="text.lighter" variant='body2'>
                                {t("Date")}
                            </Typography>
                            <Typography variant="h6">
                                {moment(failedStatus?.dateTime).format("DD/MM/YYYY - hh:mm a")}
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography fontWeight="bold" sx={{ mr: 1.5 }} color="text.lighter" variant='body2'>
                                {t("Error")}
                            </Typography>
                            <Typography>
                                {t(failedStatus?.errorMessage)}
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography fontWeight="bold" sx={{ mr: 1.5 }} color="text.lighter" variant='body2'>
                                {t("Delivery Company Response")}
                            </Typography>
                            <Typography>
                                {t(failedStatus?.deliveryCompanyResponse)}
                            </Typography>
                        </Grid>
                    </Grid>
                </DialogContent>
                <Divider />
                <CardActions>
                    <Button onClick={() => setOpen(false)} color="primary" variant="contained" sx={{ textTransform: "none" }}>
                        {t('Close')}
                    </Button>
                </CardActions>
            </Dialog>
            <Tooltip placement="top" title={t("Show fail reason")}>
                <IconButton variant="text" onClick={() => setOpen(true)} sx={{ ml: -2 }}>
                    <InfoOutlined color="primary" />
                </IconButton>
            </Tooltip>
        </>
    )
}
